module.exports = __webpack_public_path__ + "img/page6-bg.86e89f1f.png";